module.exports = __webpack_public_path__ + "img/honour-2.3bdee1ed.png";